import { Text } from '@fluentui/react';

export function OnRenderDescriptionValidationItem(element: JSX.Element) {
    return () => <div style={{ padding: '8px' }}>
        <Text variant='small' styles={{ root: { whiteSpace: 'pre-line' } }}>
            {element}
        </Text>
    </div>;
}
